// this reducer is used to store the info for new type of location challenges

// as opposed to the game.reducer which stores player / team challenges (procedually generated challenges)

import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  locations: {}, // all the locations on the scavenger hunt
  locationList: [], // the locations as a list
  challenges: {}, // all the challenges on the scavenger hunt
  huntIntro: '', // the hunt intro
  huntOutro: '', // the hunt outro
  teamPhotoUrl: '', // the team photo taken at the start of the hunt
  huntLength: 0, // the number of hunt locations
  corporateBrandingUrl: '', // a branding photo added by the corporate event
  classicChallengeList: [], // a list of the classic challenges
  timerStart: undefined, //when the hunt started (classic time limit)
  timerFinish: undefined, // when the hunt finished
  timerLimitMinutes: undefined, // the max time limiti
  currentLocationId: null,
  currentChallengeId: null,
  allChallenges: {},
};

const gameV2Slice = createSlice({
  name: 'game_v2',
  initialState,
  reducers: {
    setLocationChallengeData(state, {payload}) {
      return {
        ...state,
        locations: {...(payload.locations || {})},
        allChallenges: {...(payload.allChallenges || {})},
        locationList: [...(payload.locationList || [])],
        classicChallengeList: [...(payload.classicChallengeList || [])],
        huntIntro: payload.huntIntro,
        huntOutro: payload.huntOutro,
        huntLength: payload.huntLength,
        timerStart: payload.timerStart,
        timerFinish: payload.timerFinish,
        timerLimitMinutes: payload.timerLimitMinutes,
        corporateBrandingUrl: payload.corporateBrandingUrl,
        subChallenges: payload.subChallenges,
        backupLocationList: payload.backupLocationList,
        lastUsedBackUpBar: payload.lastUsedBackUpBar,
      };
    },

    setCurrentLocationId(state, {payload: currentLocationId}) {
      state.currentLocationId = currentLocationId;
    },
    setCurrentChallengeId(state, {payload: currentChallengeId}) {
      state.currentChallengeId = currentChallengeId;
    },
    setChallengeStartTime(state, {payload}) {
      return {
        ...state,
        challenges: {
          ...state.challenges,
          [payload.challengeId]: {
            ...state.challenges[payload.challengeId],
            startTime: Date.now(),
          },
        },
      };
    },
    setChallengeCompleteTime(state, {payload}) {
      return {
        ...state,
        challenges: {
          ...state.challenges,
          [payload.challengeId]: {
            ...state.challenges[payload.challengeId],
            completeTime: Date.now(),
          },
        },
      };
    },
  },
});

export const {
  setLocationChallengeData,
  setCurrentLocationId,
  setCurrentChallengeId,
  setChallengeStartTime,
  setChallengeCompleteTime,
} = gameV2Slice.actions;

export default gameV2Slice.reducer;
